import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  cards: {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  grid: {},
  twoRow: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
  },
  main: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 24,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      margin: 0,
    },
  },
  separator: {
    padding: '0 24px',
    color: theme.palette.secondary.dark,
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
      marginBottom: 16,
    },
  },
  dossierFacileContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  link: {
    marginTop: 8,
    display: 'block',
  },
}))

export default useStyles
